import{styled as i}from"@mui/material/styles";const t=i("div")({width:"100%"}),m=i("picture")((({theme:i})=>({display:"block",marginBottom:i.spacing(2)}))),o=i("img")({display:"block",maxWidth:"100%",height:"auto"});export{o as Image,t as ImageWrapper,m as Picture};
//# sourceMappingURL=styles.js.map
